<template>
  <ul class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="indexLink" class="nav-link text-white" active-class="active">Cajas</router-link>
    </li>
    <v-guard :permissions="['CHEQUES']">
      <li class="nav-item">
        <router-link :to="chequesdeTercerosLink" class="nav-link text-white" active-class="active">Cheques de Terceros</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="chequesPropiosLink" class="nav-link text-white" active-class="active">Cheques Propios</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="cuponesencarteraLink" class="nav-link text-white" active-class="active">Cupones en cartera</router-link>
    </li>
    <v-guard :permissions="['CAJAS_CATEGORIAS']">
      <li class="nav-item">
        <router-link :to="categoriasCajasLink" class="nav-link text-white" active-class="active">Categorias Cajas</router-link>
      </li>
    </v-guard>
    <BranchofficeSelect v-if="getHasPermission" />
  </ul>

</template>

<script>
import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";
export default {
  components: {
    BranchofficeSelect
  },
  data : function () { 
    return {
      hasPermission : false
    }
  },
  computed: {
    getHasPermission() {
        return this.hasPermission
    },
    indexLink() {
      return { name: 'Cajas' }
    },
    categoriasCajasLink() {
      return { name: 'Categorias Cajas' }
    },
    chequesdeTercerosLink() {
      return { name: 'Cheques de Terceros' }
    },
    cuponesencarteraLink() {
      return { name: 'Cupones en cartera' }
    },
    chequesPropiosLink() {
      return { name: 'Cheques Propios' }
    },
  },
  methods: {
    getAllBranchofficesFundsPermission() {
      this.$http
        .get("/api/configs/role/permissions/names", {
           headers: { 
            Authorization: "Bearer " + localStorage.getItem("token")
          },
        })
        .then((response) => {
          this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_FUNDS');
        })
    },
  },
  created() {
    this.getAllBranchofficesFundsPermission();
  },
}
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
  /* justify-content-start fijo (no solo mientras carga el selector de
     sucursal) para que no haya salto de layout al montar/desmontar. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>